"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetQueryGroups = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
function useGetQueryGroups() {
    const { data, isLoading, error, get } = (0, core_ui_1.useApiGet)('query-groups');
    const [queryGroups, setQueryGroups] = (0, react_1.useState)(data);
    (0, react_1.useEffect)(() => void (data && setQueryGroups(data)), [data]);
    return {
        queryGroups,
        loadingQueryGroups: isLoading,
        loadingQueryGroupsError: error,
        getQueryGroups: get,
        setQueryGroups
    };
}
exports.useGetQueryGroups = useGetQueryGroups;
//# sourceMappingURL=useGetQueryGroups.js.map